import { Component } from '@angular/core';
import 'rxjs/add/observable/throw';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import { Router } from '@angular/router';

@Component({
    template: `

    `
})
export class LogoutComponent  { 
    
    constructor(
        private _router: Router
    ) {
        this.logout();
    }

    logout(){
        console.log("logout");
        localStorage.setItem('session', JSON.stringify(null));
        this._router.navigate(['login']);
    }

}


// WEBPACK FOOTER //
// /var/jenkins_home/workspace/srd-poliflex-pipeline/src/app/login/logout.component.ts